  <template>
  <div>
   <b-modal style="padding:15px" size="lg" id="AddProductionModal" ref="modal" title="Add Production" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @show= "updateModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddProductionForm != undefined ? !this.$refs.AddProductionForm.checkValidity() : true">
        <form ref="AddProductionForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
           
            <div class="col-md-6">
               <b-form-group  label="Production Date" label-for="datepicker-1" autocomplete="off">
                  <b-form-datepicker id="datepicker-1" v-model= "ProDate" placeholder="Choose a date" local="en" required></b-form-datepicker>
               </b-form-group>
             
            </div>
            <div  class="col-md-6">
               <b-form-group label="Time" label-for="Time" autocomplete="off">
                <b-form-select v-model= "SelectedTimeSlot" :options="timeSlots" value-field="id" text-field="timeSlot" required>
                  <b-form-select-option :value = null disabled hidden>Select Time</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Flour Type" label-for="Flour Type" autocomplete="off">
                 <b-form-input id="flourtype" v-model= "flourObject.flourName" type = "text" disabled></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Flour Weight" label-for="Flour Weight" autocomplete="off">
                 <b-form-input id="flourweight" v-model= "flourObject.flourWeight" type = "text" disabled></b-form-input>
              </b-form-group>
            </div>
             <div class="col-md-4">
                <b-form-group  label="No Of Sacks" label-for="No Of Sacks" autocomplete="off">
                <b-form-input id="NoofSacks" v-model= "NoOfSacks" type = "number" required></b-form-input>
              </b-form-group>
            </div>
             <div class="col-md-12">
              <b-form-textarea id="textarea"  v-model= "Comments"  placeholder="Comments" rows="3" max-rows="6"></b-form-textarea>
             </div>  
          </div>     
        </form>
      </b-modal>
      <Toaster ref="toaster"/>
     </div>
    </template>
     

      <script>
import axios from 'axios';
// import config from '../config.js'; 
import Toaster from '../../toaster'
export default {
    name: 'AddProduction',
    data(){
        return{
          moduleName:'Add Production',   
      
          Comments:null,
          CompanyId:null,
        
          timeSlots:null,
          SelectedTimeSlot:null,
          SelectedFlourType:null,
          SelectedFlourWeight:null,
          NoOfSacks:0,
          ProDate:new Date(),
        
    }
    
  },
   components:
     {
      Toaster
    },
 props:{
    flourObject:{
      type:Object,
      default:null
    },
    isAdjustment:{
      type:Boolean,
      default:false
    }
  },
created()
{
  this.gettimeSlots();
  // this.getFlourWeights();
},

methods:{

  
    gettimeSlots()
    { 
        
     axios.post('/timeslots/getall', 
      { "CompanyId":this.$auth.user().companyId})
      .then(res=>{
         console.log(res.data)
            if(res.data.status == 1)
            {
               this.timeSlots = res.data.data;
            }
            else if(res.data.status == -1)
            {
                this.$bvModal.msgBoxOk(res.data.msg, {
                title: 'Error',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

  

   addProduction(){ 
    if(this.SelectedTimeSlot == null)
    {
      this.$refs.toaster.showToast("Error",'danger',"Please select time slot.")
      return;
    }
        let model =
         {
           "NoOfSacksProduced":Number(this.NoOfSacks),
           "ProductionDate":this.ProDate,
           "Description":this.Comments,
           "TimeId":this.SelectedTimeSlot,
           "UserId":this.$auth.user().id,
           "FlourWeightId":this.SelectedFlourWeight,
           "FlourTypeId":this.SelectedFlourType,
           "IsAdjustmentEntry":this.isAdjustment,
           "IsStockTakeEntry":true,
           "CompanyId":this.$auth.user().companyId
          }
          console.log(model)
     axios.post('/production/Add', model)
      .then(res=>{
            if(res.data.status == 1)
            {
                this.$refs.toaster.showToast('Success','success','Production has been added successfully');
                this.$bvModal.hide('AddProductionModal')
               this.$parent.MarkEntryAsDone(this.flourObject.flourWeightTypeLinkId);
            }
            else if(res.data.status == -1)
            {
                this.$refs.toaster.showToast('Error','danger',res.data.msg);
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.AddProductionForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
        this.NoOfSacks = 0;
        this.ProDate = new Date();
        this.SelectedTimeSlot = null;
        this.SelectedFlourType = null;
        this.SelectedFlourWeight = null;  
        this.Comments = null;
      },
        updateModal() {
        this.NoOfSacks = 0;
        this.ProDate = new Date();
        this.SelectedTimeSlot = null;
        this.SelectedFlourType = this.flourObject.flourId;
        this.SelectedFlourWeight = this.flourObject.flourWeightId;  
        this.Comments = null;
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.addProduction()
       
      },

 

  }
	

}
</script>
